import { getNotification } from '@/service/notification'
import { from } from 'rxjs'
import { tap, pluck } from 'rxjs/operators'
import { setMessage } from '@/notifications/messages'
import { verifyTrialToBasic } from '@/notifications/trialToBasic'
import { verifyTerms } from '@/notifications/termsOfUse'
import { verifySecretQuestionMissing } from '@/notifications/secret-question-missing'

function loadNotifications(app) {
  const emit = evt => modalData => app.$root.$emit(evt, modalData)
  const routerPush = (pushParams = { path: '' }) => {
    window.location.href = `${window.location.origin}/${pushParams.path}`
  }

  const notifications$ = from(getNotification()).pipe(
    pluck('data', 'notifications')
  )

  // modal para o admin que esta saíndo do trial para o básico
  notifications$.pipe(tap(verifyTrialToBasic(emit))).subscribe()

  // function para exibir todas as mensagens
  notifications$.pipe(tap(setMessage(emit, routerPush))).subscribe()

  // modal para o admin aceitar os termos de uso
  notifications$.pipe(tap(verifyTerms(emit))).subscribe()

  // modal para cadastro da pergunta secreta
  notifications$.pipe(tap(verifySecretQuestionMissing(emit))).subscribe()
}

export default {
  register: function(app) {
    app.$root.$on('app:notify:load', () => loadNotifications(app))
  },
}
